// extracted by css-extract-rspack-plugin
export default {"cls1":"TopicMarketingPage-cls1_MWd","cls2":"TopicMarketingPage-cls2__HX TopicMarketingPage-cls1_MWd"};